import { render } from "./LegacyUploadView.vue?vue&type=template&id=4326f798&scoped=true"
import script from "./LegacyUploadView.vue?vue&type=script&lang=js"
export * from "./LegacyUploadView.vue?vue&type=script&lang=js"

import "./LegacyUploadView.vue?vue&type=style&index=0&id=4326f798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4326f798"]])

export default __exports__